import { render, staticRenderFns } from "./m-chapoutier.vue?vue&type=template&id=50fc27db&scoped=true"
import script from "./m-chapoutier.vue?vue&type=script&lang=js"
export * from "./m-chapoutier.vue?vue&type=script&lang=js"
import style0 from "./m-chapoutier.vue?vue&type=style&index=0&id=50fc27db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fc27db",
  null
  
)

export default component.exports